export const DELETE_WORKFLOW_ATTACHMENT = gql`
  mutation DeleteWorkflowAttachment($id: String!) {
    deleteInvalidFile(id: $id) {
      id
    }
  }
`
